import React, { useEffect, useState } from 'react';
import { Modal, TableRow } from '@mui/material';
import {
    InfoText,
    ModalWrapper,
    SummaryTableRow,
    SummaryTableCell,
    TitleText,
    TitleWrapper,
    ButtonRow,
    Expandable,
    StyledBackdrop,
    TableWarningMessage,
    TagName
} from './Styled';
import { api } from '../../../../shared/hooks/api';
import CustomTable from '../../../../shared/components/CustomTable';
import { Product } from '../../../../data/entities';
import { EnhancedProduct } from '../types';
import { StyledTableCell } from '../../../../shared/components/CustomTable/Styled';
import DeleteIcon from '../../../../shared/svg/DeleteIcon';
import { ProductOrderProductTableColumns, OpenStateProductTableColumns } from '../../../../configs/productOrder';
import SearchBarWithSuggestion from '../../../../shared/components/SearchBar/SearchBarWithSuggestion';
import IconButton from '../../../../shared/components/IconButton';
import { sum } from 'lodash';
import TextBox from '../../../../shared/components/TextBox';
import { StyledButton } from '../../../../shared/styled/TitleBar';
import { color } from '../../../../shared/styles';
import { formatCurrency } from '../../../../utils/format';
import useMergeState from '../../../../shared/hooks/useMergeState';
// import AddAddonsModal from "../ProductList/AddonsModal";

interface ProductRowProps {
    item: any;
    extraRowProps?: any;
}

const getSelectedQuantity = (item: any) => {
    return item.selectedQuantity !== undefined ? item.selectedQuantity : 0;
};

const getMissingQuantity = (item: any) => {
    return Math.abs(Math.min(0, item.quantity - getSelectedQuantity(item)));
};

const ProductRow = ({ item, extraRowProps }: ProductRowProps) => {
    const quantity = getSelectedQuantity(item);
    const orderState = extraRowProps?.orderState || 'Open';
    const isOpenState = orderState === 'Open';

    const isQuanitySufficient = item.missingQuantity === 0 || getMissingQuantity(item) === 0;
    const backgroundColor = isQuanitySufficient ? '' : color.status.DANGER_LIGHT;
    const selectedQuantityBorderColor = isQuanitySufficient ? '' : color.status.FAIL;

    const percentDiscount = item.discount !== undefined ? item.discount : 0;
    const percentMarkup = item.markup !== undefined ? item.markup : 0;

    const price = item.item_type === 'material' 
        ? (item.material_price !== undefined ? item.material_price : 0)
        : (item.product_price !== undefined ? item.product_price : 0);

    const updateMaterialPrice = (value: string) => {
        if (extraRowProps && extraRowProps.updateMaterialPrice) {
            extraRowProps.updateMaterialPrice(item.id, Number(value));
        }
    };

    return (
        <>
            {!item.isSummary ? (
                <TableRow sx={{ backgroundColor: `${backgroundColor} !important` }}>
                    <StyledTableCell align="left">{item?.material_code || item?.product_code || "Undefined"}</StyledTableCell>
                    <StyledTableCell align="left">
                        {item.name}
                        {item.item_type && (
                            <TagName itemType={item.item_type}>
                                {item.item_type === 'product' ? 'Sản phẩm' : 'Vật tư'}
                            </TagName>
                        )}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                        {item.item_type === 'material' ? (
                            <TextBox
                                style={{
                                    borderColor: selectedQuantityBorderColor,
                                    backgroundColor,
                                    width: '160px',
                                    minWidth: '160px',
                                }}
                                text={`${(price || 0).toString()}`}
                                onChangeText={updateMaterialPrice}
                                disabled={extraRowProps.isView}
                            />
                        ) : (
                            formatCurrency(price)
                        )}
                    </StyledTableCell>
                    
                    {!isOpenState && (
                        <>
                            <StyledTableCell align="left">
                                <TextBox
                                    style={{
                                        borderColor: selectedQuantityBorderColor,
                                        backgroundColor,
                                    }}
                                    text={`${(percentDiscount || 0).toString()}`}
                                    onChangeText={(value: string) => extraRowProps.onChangeProductDiscount(item.id, Number(value))}
                                    disabled={extraRowProps.isView}
                                />
                            </StyledTableCell>
                            <StyledTableCell align="left">
                                <TextBox
                                    style={{
                                        borderColor: selectedQuantityBorderColor,
                                        backgroundColor,
                                    }}
                                    text={`${(percentMarkup || 0).toString()}`}
                                    onChangeText={(value: string) => extraRowProps.onChangeProductMarkup(item.id, Number(value))}
                                    disabled={extraRowProps.isView}
                                />
                            </StyledTableCell>
                            <StyledTableCell align="left">
                                {formatCurrency(
                                    Math.ceil(((price * (100 - percentDiscount || 0)) / 100) * ((100 + percentMarkup || 0) / 100))
                                )}
                            </StyledTableCell>
                        </>
                    )}
                    
                    <StyledTableCell align="left">{item.quantity}</StyledTableCell>
                    <StyledTableCell align="left">
                        <TextBox
                            style={{
                                borderColor: selectedQuantityBorderColor,
                                backgroundColor,
                            }}
                            text={quantity.toString()}
                            onChangeText={(value: string) => extraRowProps.updateItemSelectedQuantity(item, Number(value))}
                        />
                    </StyledTableCell>

                    {extraRowProps.isView && (
                        <StyledTableCell align="left">
                            {item.missingQuantity !== undefined ? item.missingQuantity : getMissingQuantity(item)}
                        </StyledTableCell>
                    )}

                    <StyledTableCell align="left">
                        <IconButton onClick={() => extraRowProps.removeItem(item)}>
                            <DeleteIcon />
                        </IconButton>
                    </StyledTableCell>
                </TableRow>
            ) : (
                <SummaryTableRow>
                    <SummaryTableCell align="left">{item.id}</SummaryTableCell>
                    <SummaryTableCell align="left">{item.name}</SummaryTableCell>
                    <SummaryTableCell align="left">{formatCurrency(item.price)}</SummaryTableCell>
                    
                    {!isOpenState && (
                        <>
                            <SummaryTableCell align="left"></SummaryTableCell>
                            <SummaryTableCell align="left"></SummaryTableCell>
                            <SummaryTableCell align="left"></SummaryTableCell>
                        </>
                    )}
                    
                    <SummaryTableCell align="left"></SummaryTableCell>
                    <SummaryTableCell align="left"></SummaryTableCell>

                    {extraRowProps.isView && <SummaryTableCell align="left"></SummaryTableCell>}

                    <SummaryTableCell align="left"></SummaryTableCell>
                </SummaryTableRow>
            )}
        </>
    );
};

interface AddProductModalProps {
    onChangeProductSelectedQuantity: Function;
    selectedProducts: any[];
    open: boolean;
    handleClose: any;
    mergeProductOrder: Function;
    isView?: boolean;
    customerCategory?: string;
    customerId?: string;
    orderState?: string;
}

const AddProductModal = ({
    selectedProducts,
    open,
    handleClose,
    mergeProductOrder,
    isView,
    customerCategory,
    customerId,
    orderState = 'Open',
}: AddProductModalProps) => {
    const [isOpen, setIsOpen] = useState(open);
    const [searchItems, setSearchItems] = useState<EnhancedProduct[]>([]);

    const productsApiUrl = `/customers/${customerId}/products/?is_active=true&page_size=${Number.MAX_SAFE_INTEGER}${
        customerCategory ? '&category=' + customerCategory.split(';').join(',') : ''
    }`;

    const materialsApiUrl = `/materials?is_active=true&page_size=${Number.MAX_SAFE_INTEGER}`;

    const [{ data: productsData }, fetchProducts] = api.get(productsApiUrl, undefined, true);
    const [{ data: materialsData }, fetchMaterials] = api.get(materialsApiUrl, undefined, true);

    const [selectedItems, setSelectedItems] = useMergeState(selectedProducts);
    
    useEffect(() => {
        const products = productsData && productsData.results ? 
            productsData.results.map((product: Product) => ({ 
                ...product, 
                item_type: 'product', 
                product_price: product.customer_price ?? 0
            })) : [];
            
        const materials = materialsData && materialsData.results ? 
            materialsData.results.map((material: any) => ({ 
                ...material, 
                item_type: 'material', 
                material_price: material.material_price || 0
            })) : [];
        
        setSearchItems([...products, ...materials] as EnhancedProduct[]);
    }, [productsData, materialsData]);

    const summaryProduct = {
        id: `Tổng ${selectedItems.length} mục`,
        name: 'Subtotal',
        price: sum(
            selectedItems.map((item: any) => {
                const discount = item.discount || 0;
                const markup = item.markup || 0;
                const itemPrice = item.item_type === 'material' ? item.material_price : item.product_price;
                const discountedPrice = Math.ceil(((itemPrice * (100 - discount)) / 100) * ((100 + markup) / 100));
                return discountedPrice * (item.selectedQuantity || 0);
            })
        ),
        isSummary: true,
    };
    const tableItems = selectedItems.length === 0 ? [] : [...selectedItems, summaryProduct];

    const isSufficient = tableItems.every(
        (item: any) => item.isSummary || item.missingQuantity === 0 || getMissingQuantity(item) === 0
    );

    const removeSelectedItem = (removedItem: EnhancedProduct) => {
        const removedSelectedItems = selectedItems.filter((selectedItem: EnhancedProduct) =>
            !(selectedItem.id === removedItem.id && selectedItem.item_type === removedItem.item_type)
        );
        setSelectedItems(removedSelectedItems);
    };

    const updateItemSelectedQuantity = (item: EnhancedProduct, selectedQuantity: number) => {
        const updatedSelectedItems = selectedItems.map((product: any) => {
            if (product.id === item.id) {
                const missingQuantity = Math.abs(
                    Math.min(0, product.quantity - selectedQuantity)
                );
                return {
                    ...product,
                    selectedQuantity,
                    missingQuantity,
                };
            }
            return product;
        });
        setSelectedItems(updatedSelectedItems);
    };

    const updateItemAddOns = (item: EnhancedProduct, addons: any[]) => {
        const updatedSelectedItems = selectedItems.map((product: any) => {
            if (product.id === item.id) {
                return { ...item, addons };
            }

            return product;
        });

        setSelectedItems(updatedSelectedItems);
    };

    const onChangeProductDiscount = (id: string, discount: any) => {
        const updatedSelectedItems = selectedItems.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    discount,
                };
            }
            return item;
        });
        setSelectedItems(updatedSelectedItems);
    };

    const onChangeProductMarkup = (id: string, markup: any) => {
        const updatedSelectedItems = selectedItems.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    markup,
                };
            }
            return item;
        });
        setSelectedItems(updatedSelectedItems);
    };

    const updateMaterialPrice = (id: string, materialPrice: number) => {
        const updatedSelectedItems = selectedItems.map((item: any) => {
            if (item.id === id) {
                return {
                    ...item,
                    material_price: materialPrice,
                };
            }
            return item;
        });
        setSelectedItems(updatedSelectedItems);
    };

    const handleOnclickItem = (item: EnhancedProduct, isAdded: boolean) => {
        const isItemContained = selectedItems.some((selectedItem: any) => 
            selectedItem.id === item.id
        );
        if (isAdded && !isItemContained) {
            setSelectedItems([
                ...selectedItems,
                {
                    ...item,
                },
            ]);
        } else if (!isAdded && isItemContained) {
            removeSelectedItem(item);
        }
    };

    const onClickAddProducts = () => {
        const typedItems = selectedItems as EnhancedProduct[];
        const products = typedItems.filter(item => !item.item_type || item.item_type === 'product');
        const materials = typedItems.filter(item => item.item_type === 'material');
        
        mergeProductOrder({ 
            products: products,
            materials: materials
        });
        
        handleClose();
    };

    const handleCloseWithAnimation = () => {
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    useEffect(() => {
        if (open) {
            setIsOpen(true);
        } else {
            const timer = setTimeout(() => setIsOpen(false), 200);
            return () => clearTimeout(timer);
        }
    }, [open]);

    const getColumns = () => {
        const isOpenState = orderState === 'Open';
        const baseColumns = isOpenState ? OpenStateProductTableColumns : ProductOrderProductTableColumns;
        
        return isView
            ? baseColumns
            : baseColumns.filter((item) => item.text !== 'Số lượng thiếu');
    };

    const fetchItems = (variables: any) => {
        fetchProducts({
            ...variables,
        });
        fetchMaterials({
            ...variables,
        });
    };

    return (
        <Modal
            open={open}
            onClose={handleCloseWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper isOpen={isOpen}>
                <Expandable>
                    <TitleWrapper>
                        <TitleText>Thêm sản phẩm và vật tư</TitleText>
                        <InfoText>Vui lòng lựa chọn sản phẩm hoặc vật tư</InfoText>
                    </TitleWrapper>

                    <SearchBarWithSuggestion
                        menuList={searchItems}
                        selectedItems={selectedItems}
                        fetchItems={fetchItems}
                        handleOnclickItem={handleOnclickItem}
                        placeholder="Tìm kiếm theo từ khoá Mã sản phẩm, Tên sản phẩm, Mã vật tư, Tên vật tư"
                    />

                    {!isSufficient && (
                        <TableWarningMessage>
                            Cảnh báo số lượng yêu cầu vượt quá số lượng tồn kho. Cần sản xuất thêm sau khi tạo đơn hàng
                        </TableWarningMessage>
                    )}

                    <CustomTable
                        itemList={tableItems}
                        RowElement={ProductRow}
                        TableColumns={getColumns()}
                        extraRowProps={{
                            removeItem: removeSelectedItem,
                            updateItemSelectedQuantity,
                            onChangeProductDiscount,
                            onChangeProductMarkup,
                            updateItemAddOns,
                            updateMaterialPrice,
                            isView,
                            orderState,
                        }}
                        containerStyle={{ maxHeight: '400px' }}
                    />
                </Expandable>

                <ButtonRow>
                    <StyledButton onClick={handleCloseWithAnimation}>Huỷ bỏ</StyledButton>
                    <StyledButton variant="contained" onClick={onClickAddProducts}>
                        Lưu
                    </StyledButton>
                </ButtonRow>
            </ModalWrapper>
        </Modal>
    );
};

export default AddProductModal;
